import { Stack } from "@mui/material";
import { UseFormReturn, Controller } from "react-hook-form";
import * as yup from "yup";

import { CouponModel, useGetCouponType, useGetMerchants } from "../coupon";
import { DatePicker, FormInput, FormSelect } from "../../../atoms";
import { YupShape } from "../../../shared";
import { useMemo } from "react";

export const couponSchema = yup
  .object<YupShape<CouponModel>>({
    code: yup.string().required(),
    type: yup.string().required(),
    value: yup.number().positive("Value must be positive between 0 and 100").required("Required"),
  })
  .required();
type CouponEditorViewProps = {
  form: UseFormReturn<CouponModel, any>;
};
export const CouponEditorView = ({
  form: {
    control,
    register,
    formState: { errors },
  },
}: CouponEditorViewProps) => {
  const { data: couponTypes } = useGetCouponType();
  const { data: merchants } = useGetMerchants();

  const merchantNames = useMemo(() => {
    if (!merchants) return [];

    return merchants.filter((x) => x.isActive);
  }, [merchants]);

  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row">
        <FormInput label="Coupon Code" {...register("code")} helperText={errors.code?.message} />
      </Stack>
      <Stack direction="row" spacing={2}>
        <Controller control={control} name="type" render={({ field }) => <FormSelect {...field} label={"Category Type"} options={couponTypes} />} />
        <FormInput label="Value(%)" {...register("value")} helperText={errors.value?.message} />
      </Stack>

      <Stack spacing={2} direction="row">
        <FormInput label="Maximum Cap" {...register("maximumCap")} helperText={errors.maximumCap?.message} />
        <FormInput label="Minimum Cap" {...register("minimumCap")} helperText={errors.minimumCap?.message} />
      </Stack>
      <Stack spacing={2} direction="row">
        <Controller control={control} name="startDate" render={({ field: { value, onChange } }) => <DatePicker value={value} label={"Start Date"} onChange={(e) => onChange(e)} />} />
        <Controller control={control} name="expiryDate" render={({ field: { value, onChange } }) => <DatePicker value={value} label={"Expiry Date"} onChange={(e) => onChange(e)} />} />
      </Stack>
      <Stack spacing={2} direction="row">
        <FormInput label="Usage Per User" {...register("usagePerUser")} helperText={errors.usagePerUser?.message} />

        <FormInput label="Total Usage" {...register("totalUsage")} helperText={errors.value?.message} />
      </Stack>
    </Stack>
  );
};
